
import CreateStockJournal from './CreateStockJournal';

export default CreateStockJournal;

